import { Box, Skeleton, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { utils as commonUtils } from '@finley-technologies/common';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { FinancialCovenantsContainer } from 'packages/borrowing-base/ui/FinancialCovenantsContainer';
import {
  InsightsTemplate,
  TAB_OPTION_KEYS,
} from 'packages/borrowing-base/ui/InsightsTemplate';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';

export const InsightsFinancialCovenantsRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { data: userData } = useGetUserQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = commonUtils.EnvUtils.isProduction()
        ? 'An unexpected error occurred. Please contact Finley for support.'
        : err.message;
      toast(errorToastConfig);
    },
  });

  if (!userData || !userData.user) {
    return <Skeleton height="600px" data-testid="insights-route-loading" />;
  }

  let routeLevelError = false;

  return (
    <Box>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load insights financial covenants page`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <InsightsTemplate
          selectedTab={TAB_OPTION_KEYS.financialCovenants}
          organizationId={userData?.user?.organizationId}
        >
          <FinancialCovenantsContainer />
        </InsightsTemplate>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
